const baseUrl = '/openapi'
export default {
  "sendEmailCode": baseUrl + "/user/sendEmailCode",
  "sendSmsCode": baseUrl + "/user/sendSmsCode",
  "login": baseUrl + "/user/login",
  "register": baseUrl + "/user/register",
  "editDept": baseUrl + "/user/editDept",
  "editUser": baseUrl + "/user/editUser",
  "updateBusinessManager": baseUrl + "/user/updateBusinessManager",
  "docList": baseUrl + "/doc/list",
  "docId": baseUrl + "/doc/",
  "userAppKey": baseUrl + "/user/appKey/list",
  "getUserById": baseUrl + "/user/getUserById",
  "fetchConfig": baseUrl + "/config/fetchConfig",
  "appKeyConfig": baseUrl + "/appKeyConfig",
  "getByAppKey": baseUrl + "/appKeyConfig/getByAppKey",
  "editAppKeyConfig": baseUrl + "/appKeyConfig",
  "getStstoken": baseUrl + "/common/getStstoken",
  "getDeviceSetting": baseUrl + "/config/getDeviceSetting",
  "addDeviceSetting": baseUrl + "/config/addDeviceSetting",
  "workorderList": baseUrl + "/system/workorder/list",
  "getRequestDataList": baseUrl + "/wifi/demo/getRequestData",
  "workorderExport": baseUrl + "/system/workorder/export",
  "workorder": baseUrl + "/system/workorder",
  "replyWorkorder": baseUrl + "/system/workorder/reply",
  "xinmiao_workorder_type": baseUrl + "/system/dict/data/type/xinmiao_workorder_type",
  "holtekApply": baseUrl + "/holtekSecret/apply",
  "holtekApplyList": baseUrl + "/holtekSecret/applyList",
  "computeLibraryAlgorithms": baseUrl + "/computeLibrary/algorithms",
  "computeLibraryApply": baseUrl + "/computeLibrary/apply",
  // "editAppKeyConfig": baseUrl + "/common/getStstoken",
}



// WEBPACK FOOTER //
// ./src/api/api.js